import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const LinkExpired = () => {
  const {t}=useTranslation("")
  return (
    <div className="page404Wrapper">
      <div className="page404Content text-center">
        <em
            style={{fontSize: '7.5em'}}
            className="fa-solid fa-link-slash mx-auto mb-5"
        />
        <h3 className="mb-4">{t("LinkExpiredPage.heading")}</h3>
        <Link to="/" className="fontsize-16 fw700 color-active">{t("LinkExpiredPage.backToHome")}</Link>
      </div>
    </div>
  );
};

export default LinkExpired;
